/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export function getEndpoints(
  apiUrl: string,
  companyUrl?: string,
  deliveryUrl?: string,
  administrationUrl?: string,
  gatewayUrl?: string
) {
  return {
    apiUrl: apiUrl,
    wsEndpointUrl: `${gatewayUrl || apiUrl}/company/ws`,
    wsDeliveryEndpointUrl: `${gatewayUrl || apiUrl}/delivery/ws`,
    wsAdministrationEndpointUrl: `${gatewayUrl || apiUrl}/administration/ws`,

    loggedInContextUrl: `${apiUrl}/company/api/logged-in-context`,
    authUrl: `${apiUrl}/authorization/api`,
    usersUrl: `${apiUrl}/authorization/api/auth/users`,
    rolesUrl: `${apiUrl}/authorization/api/auth/roles`,
    authLogsUrl: `${apiUrl}/authorization/api/auth/authLogs`,
    ownedAuthLogsUrl: `${apiUrl}/authorization/api/auth/ownedAuthLogs`,
    loginUrl: `${apiUrl}/authorization/api/auth/login`,
    userPushNotificationTokenUrl: `${apiUrl}/authorization/api/auth/push-token`,
    initialRoleAssignmentUrl: `${apiUrl}/authorization/api/assign-initial-roles`,
    roleCompanyTypeUrl: `${apiUrl}/authorization/api/auth/roles/company-type`,

    cofaceCountriesUrl: `${apiUrl}/company/api/iriro/coface/country`,
    bankAccountUrl: `${apiUrl}/company/api/bankaccount`,
    creditCardUrl: `${apiUrl}/company/api/creditcard`,
    subscriptionTypeUrl: `${apiUrl}/company/api/subscriptionTypes`,
    subscriptionUrl: `${apiUrl}/company/api/subscription`,
    companyBusinessProfileUrl: `${apiUrl}/company/api/businessprofile`,
    invitationEmailUrl: `${apiUrl}/company/api/company-email`,
    companyAddressUrl: `${apiUrl}/company/api/addresses`,
    companyCustomerUrl: `${apiUrl}/company/api/customer`,
    companyTerritoryUrl: `${apiUrl}/company/api/territory`,
    companyContactUrl: `${apiUrl}/company/api/contacts`,
    companyActionsUrl: `${apiUrl}/company/api/actions`,
    companyEmployeeUrl: `${apiUrl}/company/api/employees`,
    companyPersonUrl: `${apiUrl}/company/api/companyPerson`,
    companyLegalEntityLocalUrl: `${apiUrl}/company/api/legalEntity/local`,
    companyRegistrationUrl: `${apiUrl}/company/api/legalEntity/signup`,
    companyLegalEntityAnafUrl: `${apiUrl}/company/api/legalEntity/anaf`,
    companyLegalEntityCofaceUrl: `${apiUrl}/company/api/legalEntity/coface`,
    serviceProviderUrl: `${apiUrl}/company/api/service-provider`,
    notificationsUrl: `${apiUrl}/company/api/notifications`,
    companyEmployeeVoUrl: `${apiUrl}/company/api/employees/employeeVos`,
    termsAndConditionsUrl: `${apiUrl}/company/api/terms-and-conditions`,
    termsAndConditionsAgreementUrl: `${apiUrl}/company/api/terms-and-conditions-agreement`,
    legalEntityTermsAndConditionsUrl: `${apiUrl}/company/api/le-terms-and-conditions`,
    userActionTrackingUrl: `${apiUrl}/company/api/iriro/user-action-tracking`,
    signupFirstContactUrl: `${apiUrl}/company/api/signup/first-contact`,
    legalEntitySubscriptionServiceProviderUrl: `${apiUrl}/company/api/legal-entity-subscription`,
    subscriptionHistoryServiceProviderUrl: `${apiUrl}/company/api/subscription-history`,
    platformInvoiceServiceProviderUrl: `${apiUrl}/company/api/platform-invoice`,
    platformLegalEntityUrl: `${apiUrl}/company/api/platform-legal-entity`,
    platformInvoiceUrl: `${apiUrl}/company/api/platform-invoice`,
    platformInvoicePaymentUrl: `${apiUrl}/company/api/platform-invoice-payment`,
    companyActionsPerformed: `${apiUrl}/company/api/performed-actions`,
    platformCompanyContactFormUrl: `${apiUrl}/company/api/platform-company-contact-form`,
    companyUserUrl: `${apiUrl}/company/api/company-user`,
    anafAuthenticationUrl: `${apiUrl}/company/api/anaf-authentication`,
    actionPaymentUrl: `${apiUrl}/company/api/pay`,
    companySelfSignupCardsUrl: `${apiUrl}/company/api/self-signup-cards`,

    customerUrl: `${apiUrl}/crm/api/customer/v2`,
    customerVoUrl: `${apiUrl}/crm/api/customer/vo/customerSummaryVos`,
    customerAddressUrl: `${apiUrl}/crm/api/customer/addresses`,
    customerContactsUrl: `${apiUrl}/crm/api/customer/contacts/v2`,
    customerAttachmentsUrl: `${apiUrl}/crm/api/customer/attachments`,

    opportunityUrl: `${apiUrl}/crm/api/opportunity`,
    opportunityAddressUrl: `${apiUrl}/crm/api/opportunity/addresses`,
    opportunityContactUrl: `${apiUrl}/crm/api/opportunity/contact`,
    activityUrl: `${apiUrl}/crm/api/activity`,
    activityAddressUrl: `${apiUrl}/crm/api/activity/addresses`,
    activityContactUrl: `${apiUrl}/crm/api/activity/contact`,
    salesUrl: `${apiUrl}/crm/api/sales`,
    salesTerritoryUrl: `${apiUrl}/crm/api/sales-territory`,
    opportunityOverviewUrl: `${apiUrl}/crm/api/opportunity/overview`,
    customerProfileUrl: `${apiUrl}/crm/api/customer-profile`,
    customerCreditUrl: `${apiUrl}/crm/api/customer-credit`,
    serviceUrl: `${apiUrl}/crm/api/service`,
    customerOverviewUrl: `${apiUrl}/crm/api/customer/overview`,
    customerActivityOverviewUrl: `${apiUrl}/crm/api/activity/customer-overview`,
    customerOpportunityOverviewUrl: `${apiUrl}/crm/api/opportunity/customer-overview`,
    customerContactOverviewUrl: `${apiUrl}/crm/api/customer/contacts/overview`,
    customerContractOverviewUrl: `${apiUrl}/crm/api/contract/customer-overview`,
    crmAccountUrl: `${apiUrl}/crm/api/account`,
    globalAccountUrl: `${apiUrl}/crm/api/customer/globalAccount`,
    crmEmployeeVoUrl: `${apiUrl}/crm/api/employees/employeeVos`,
    crmServiceProviderUrl: `${apiUrl}/crm/api/service-provider`,

    invoiceUrl: `${apiUrl}/delivery/api/invoice`,
    customerInvoiceUrl: `${apiUrl}/delivery/api/invoice/customer`,
    invoiceItemUrl: `${apiUrl}/delivery/api/invoiceItem`,
    vatUrl: `${apiUrl}/delivery/api/vat`,
    invoiceDateChangeRequestUrl: `${apiUrl}/delivery/api/invoice-date-change-request`,

    vehicleUrl: `${apiUrl}/delivery/api/vehicle`,
    vehicleFinancialUrl: `${apiUrl}/delivery/api/vehicle-financial`,
    vehicleFuelCardUrl: `${apiUrl}/delivery/api/fuel-card`,
    vehicleFinancialCompanyUrl: `${apiUrl}/delivery/api/vehicle-financial-company`,
    vehicleEquipmentUrl: `${apiUrl}/delivery/api/vehicle-equipment`,
    equipmentUrl: `${apiUrl}/delivery/api/equipment`,
    vehicleDocumentUrl: `${apiUrl}/delivery/api/vehicle-document`,
    documentUrl: `${apiUrl}/delivery/api/document`,
    documentTransferUrl: `${apiUrl}/delivery/api/document-transfer`,
    driverUrl: `${apiUrl}/delivery/api/driver`,
    driverVehicleUrl: `${apiUrl}/delivery/api/driver-vehicle`,
    driverDocumentUrl: `${apiUrl}/delivery/api/driver-document`,
    driverLicenseUrl: `${apiUrl}/delivery/api/driver-license`,
    driverTimesheetUrl: `${apiUrl}/delivery/api/driver-timesheet`,
    identityDocumentUrl: `${apiUrl}/delivery/api/identity-document`,
    driverExpenseUrl: `${apiUrl}/delivery/api/driver-expense`,
    driverExpenseRequestUrl: `${apiUrl}/delivery/api/driver-expense-request`,
    averageRoutingCostUrl: `${apiUrl}/delivery/api/average-routing-cost`,
    routeUrl: `${apiUrl}/delivery/api/route`,
    businessProfileUrl: `${apiUrl}/delivery/api/business-profile`,
    deliveryEmployeeUrl: `${apiUrl}/delivery/api/employee`,
    deliveryEmployeeVOsUrl: `${apiUrl}/delivery/api/employee/vos`,
    distanceUrl: `${apiUrl}/delivery/api/distance`,
    timezoneUrl: `${apiUrl}/delivery/api/timezone`,
    deliveryDispatcherResourceUrl: `${apiUrl}/delivery/api/employee/dispatcher-resource`,
    offerRequestUrl: `${apiUrl}/delivery/api/offer-request`,
    preOfferRequestUrl: `${apiUrl}/delivery/api/offer-request/pre-offer-request`,
    customerOfferRequestUrl: `${apiUrl}/delivery/api/customer-offer-request`,
    serviceProviderOfferRequestUrl: `${apiUrl}/delivery/api/service-provider-offer-request`,
    offerRequestCancelUrl: `${apiUrl}/delivery/api/customer-offer-request/cancel`,
    productCustomsCustomsClearanceUrl: `${apiUrl}/delivery/api/product-customs-clearance`,
    tariffUrl: `${apiUrl}/delivery/api/tariff`,
    agentZoneUrl: `${apiUrl}/delivery/api/zones/zoneVos`,
    contractVOUrl: `${apiUrl}/delivery/api/contract/vo`,
    contractUrl: `${apiUrl}/delivery/api/contract`,
    emailUrl: `${apiUrl}/delivery/api/emails`,
    accountUrl: `${apiUrl}/delivery/api/account`,
    customerAccountUrl: `${apiUrl}/delivery/api/account/customer`,
    plannerOrderUrl: `${apiUrl}/delivery/api/planner-order`,
    deliveryServiceUrl: `${apiUrl}/delivery/api/delivery-service`,
    deliveryCustomerUrl: `${apiUrl}/delivery/api/customer`,
    delAddressListUrl: `${apiUrl}/delivery/api/address/list`,
    deliveryCustomerDetailsUrl: `${apiUrl}/delivery/api/customer-details`,
    orderUrl: `${apiUrl}/delivery/api/order`,
    orderPreview: `${apiUrl}/delivery/api/order/preview`,
    preOrderUrl: `${apiUrl}/delivery/api/order/preorder`,
    linkablePreOrderAutocompleteUrl: `${apiUrl}/delivery/api/order/preorder/unlinked`,
    spOrderBulkActionUrl: `${apiUrl}/delivery/api/planner-order/bulk`,
    customerOrderListUrl: `${apiUrl}/delivery/api/customer-order-list`,
    customerOrderUrl: `${apiUrl}/delivery/api/customer-order`,
    orderCancelRequestUrl: `${apiUrl}/delivery/api/order/cancel-request`,
    routingSolutionUrl: `${apiUrl}/delivery/api/routing-solution`,
    masterRoutingSolutionUrl: `${apiUrl}/delivery/api/master-routing-solution`,
    offerUrl: `${apiUrl}/delivery/api/offer`,
    countryUrl: `${apiUrl}/delivery/api/country`,
    countyUrl: `${apiUrl}/delivery/api/county`,
    taskUrl: `${apiUrl}/delivery/api/task`,
    complaintUrl: `${apiUrl}/delivery/api/complaint`,
    deliveryServiceProviderUrl: `${apiUrl}/delivery/api/service-provider`,
    delTerritoryUrl: `${apiUrl}/delivery/api/territory`,
    delTerritoryAssignmentUrl: `${apiUrl}/delivery/api/territory-assignment`,
    delTerritoryVoUrl: `${apiUrl}/delivery/api/territory/territoryVos`,
    delAddressTemplateUrl: `${apiUrl}/delivery/api/address-template`,
    vendorUrl: `${apiUrl}/delivery/api/vendor`,
    vendorTagUrl: `${apiUrl}/delivery/api/vendor-tag`,
    resendEmailUrl: `${apiUrl}/delivery/api/email/resend`,
    shipmentAttachmentUrl: `${apiUrl}/delivery/api/shipment-attachment`,
    shipmentUrl: `${apiUrl}/delivery/api/shipment`,
    shipmentPdfUrl: `${apiUrl}/delivery/api/shipment-pdf`,
    shipmentRoutingUrl: `${apiUrl}/delivery/api/shipment-routing`,
    shipmentRequestUrl: `${apiUrl}/delivery/api/shipment-request`,
    shipmentStatusChangeUrl: `${apiUrl}/delivery/api/shipment/status`,
    offerChatThreadUrl: `${apiUrl}/delivery/api/offer/chat/thread`,
    offerChatMessageUrl: `${apiUrl}/delivery/api/offer/chat/messages`,
    pdfReporting: `${apiUrl}/administration/api`,

    packagesUrl: `${apiUrl}/delivery/api/packages`,
    shipmentPackagesUrl: `${apiUrl}/delivery/api/packages/vos/shipment`,
    customerOrderOverviewUrl: `${apiUrl}/delivery/api/order/customer-overview`,
    customerBillingOverviewUrl: `${apiUrl}/delivery/api/invoice/customer-overview`,
    shipmentGroupUrlUrl: `${apiUrl}/delivery/api/shipment-group`,
    shipmentTrackingUrl: `${apiUrl}/delivery/api/shipment-tracking-list`,
    shipmentSolutionOverviewUrl: `${apiUrl}/delivery/api/shipment-solution-overview`,
    serviceProviderShipmentSolutionUrl: `${apiUrl}/delivery/api/service-provider-shipment-solution`,
    serviceProviderShipmentRequestSolutionUrl: `${apiUrl}/delivery/api/service-provider-shipment-request-solution`,
    shipmentDraftsUrl: `${apiUrl}/delivery/api/shipment-draft`,
    segmentDefinitionUrl: `${apiUrl}/delivery/api/segment-definition`,
    segmentRouteUrl: `${apiUrl}/delivery/api/segment-route`,
    shipmentCustomerTemplateUrl: `${apiUrl}/delivery/api/shipment-customer-template`,
    shipmentVendorTemplateUrl: `${apiUrl}/delivery/api/shipment-vendor-template`,
    shipmentGroupSolutionUrl: `${apiUrl}/delivery/api/shipment-group/solution`,
    multiOrderFullChainRoutingUrl: `${apiUrl}/delivery/api/shipment-group/solution/multi-order-full-chain-routing`,
    multiOfferRequestFullChainRoutingUrl: `${apiUrl}/delivery/api/shipment-group/solution/multi-offer-request-full-chain-routing`,
    shipmentGroupSolutionTrackingUrl: `${apiUrl}/delivery/api/shipment-group/solution-tracking`,
    shipmentGroupSolutionSegmentUrl: `${apiUrl}/delivery/api/shipment-group/solution-segment`,
    shipmentTransactionTermsAndCondAgreementUrl: `${apiUrl}/delivery/api/ship-transaction-tc-agreement`,
    delLegalEntityTermsAndConditionsUrl: `${apiUrl}/delivery/api/le-terms-and-conditions`,
    shipmentTimelineUrl: `${apiUrl}/delivery/api/timeline`,
    deliveryInboxUrl: `${apiUrl}/delivery/api/inbox`,
    project44Url: `${apiUrl}/delivery/api/project44`,
    deliveryOutboxUrl: `${apiUrl}/delivery/api/outbox`,
    delContactEmailableUrl: `${apiUrl}/delivery/api/contact/emailable`,
    delNotifiableContactUrl: `${apiUrl}/delivery/api/notifiable-contact`,
    deliveryBankAccountUrl: `${apiUrl}/delivery/api/bank-account`,
    scheduledShipmentUrl: `${apiUrl}/delivery/api/scheduled-shipment`,
    standardPackageDimensionUrl: `${apiUrl}/delivery/api/standard-package-dimension`,
    customerContractsUrl: `${apiUrl}/delivery/api/contract-tariff/customer`,
    customerServiceProviderUrl: `${apiUrl}/delivery/api/contract-tariff`,
    contractRequestUrl: `${apiUrl}/delivery/api/contract-tariff-request`,
    contractTariffItemListUrl: `${apiUrl}/delivery/api/contract-tariff-item`,
    packageContractTariffItemListUrl: `${apiUrl}/delivery/api/package-contract-tariff-item/list`,
    contractResponseUrl: `${apiUrl}/delivery/api/contract-tariff`,
    matrixContractUrl: `${apiUrl}/delivery/api/matrix-contract`,
    matrixContractTariffQuoteUrl: `${apiUrl}/delivery/api/matrix-contract-tariff`,
    contractMeasureFormulaUrl: `${apiUrl}/delivery/api/contract-measure-formula`,
    contractTariffCancelRequestUrl: `${apiUrl}/delivery/api/contract-tariff/cancel-request`,
    tariffSupplierDelegationUrl: `${apiUrl}/delivery/api/tariff-supplier-delegation`,
    supplierDelegationUrl: `${apiUrl}/delivery/api/supplier-delegation/list`,
    dispatcherRouteUrl: `${apiUrl}/delivery/api/dispatcher-route`,
    dispatcherShipmentOverviewUrl: `${apiUrl}/delivery/api/dispatcher-shipment-overview`,
    dispatcherShipmentPackage: `${apiUrl}/delivery/api/shipment-package`,
    dispatcherTaskPackage: `${apiUrl}/delivery/api/task-package`,
    taskCheckpointUrl: `${apiUrl}/delivery/api/task-checkpoint`,
    delLegalEntityUrl: `${apiUrl}/delivery/api/legal-entity`,
    deliverySelfSignupCardsUrl: `${apiUrl}/delivery/api/self-signup-cards`,
    exchangeRateUrl: `${apiUrl}/delivery/api/exchange-rate`,

    importDefinitionUrl: `${apiUrl}/administration/api/import/definition`,
    importExecutionUrl: `${apiUrl}/administration/api/import/execution`,
    exceptionsUrl: `${apiUrl}/administration/api/exceptions`,
    jobSystemBasePathUrl: `${apiUrl}/administration`,
    actionsUrl: `${apiUrl}/administration/api/actions`,
    tutorialUrl: `${apiUrl}/administration/api/tutorial`,
    alertNotificationUrl: `${apiUrl}/administration/api/alert-notification`,
    companyAssetUrl: `${apiUrl}/administration/api/company-asset`,
    selectItemsUrl: `${apiUrl}/administration/api/selectitems`,
    selectItemsProviderUrl: `${apiUrl}/administration/api/selectitems/provider`,
    reportingBasePathUrl: `${apiUrl}/administration/api`,

    preferencesUrl: `${apiUrl}/authorization/api/preferences`,

    invoiceGroupPayment: `${apiUrl}/delivery/api/invoice-group-payment`,
    invoicePartialPayment: `${apiUrl}/delivery/api/invoice-partial-payment`,
    invoiceAssociation: `${apiUrl}/delivery/api/invoice-external-automated-order-list`,

    delCostCenterUrl: `${apiUrl}/delivery/api/cost-center`,

    costUrl: `${apiUrl}/delivery/api/cost`,

    workflowsUrl: `${apiUrl}/administration/api/workflow`,
    workflowConfigUrl: `${apiUrl}/administration/api/workflow/config`,

    paymentMethodUrl: `${apiUrl}/company/api/payment-method`,
    paymentMethodSaveUrl: `${apiUrl}/company/api/payment-method`,

    consolidationUrl: `${apiUrl}/delivery/api/consolidation`,
    shipmentGroupConsolidationUrl: `${apiUrl}/delivery/api/consolidation/shipment-group`,

    warehousesUrl: `${apiUrl}/delivery/api/warehouse`,
    terminalUrl: `${apiUrl}/delivery/api/terminal`,
    terminalReservationUrl: `${apiUrl}/delivery/api/terminal-reservation`,
    terminalAutocompleteUrl: `${apiUrl}/delivery/api/terminal/autocomplete-list`,
    terminalGateUrl: `${apiUrl}/delivery/api/terminal-gate`,
    budgetManagementUrl: `${apiUrl}/delivery/api/budget-management`,

    cashFlowUrl: `${apiUrl}/delivery/api/cashflow`,
    cashFlowListUrl: `${apiUrl}/delivery/api/cashflow/list`,
    cashFlowItemUrl: `${apiUrl}/delivery/api/cashflow-item`,
    cashFlowItemListUrl: `${apiUrl}/delivery/api/cashflow-item/list`,

    eFacturaUrl: `${apiUrl}/delivery/api/efactura`,
    anafMessageListUrl: `${apiUrl}/delivery/api/anaf-invoice-message-list`,
    anafInvoiceMessagesUrl: `${apiUrl}/delivery/api/efactura-messages`,

    partnerRouteShareLocationUrl: `${apiUrl}/delivery/api/partner-route-share-location`,
    routeShareLocationUrl: `${apiUrl}/delivery/api/route-share-location`,

    transportProjectUrl: `${apiUrl}/delivery/api/transport-project`,

    gpsVehicleRoute: `${apiUrl}/delivery/api/vehicle-route`,

    eTransportNotificationUrl: `${apiUrl}/delivery/api/etransport/notification`,
    eTransportModifVehicleUrl: `${apiUrl}/delivery/api/etransport/modif-vehicle`,
    eTransportCollaborationUrl: `${apiUrl}/delivery/api/etransport/collaboration`,
    eTransportIntegrationUrl: `${apiUrl}/delivery/api/etransport/integration`,
    eTransportOperationPlacesTypesUrl: `${apiUrl}/delivery/api/etransport/operation-places-types`,
    eTransportDocumentTypeUrl: `${apiUrl}/delivery/api/etransport/document-type`,
    eTransportOperationTypeUrl: `${apiUrl}/delivery/api/etransport/operation-type`,
    eTransportConfirmationTypeUrl: `${apiUrl}/delivery/api/etransport/confirmation-type`,
    eTransportPtfUrl: `${apiUrl}/delivery/api/etransport/ptf`,
    eTransportCustomsOfficeUrl: `${apiUrl}/delivery/api/etransport/customs-office`,
    eTransportOperationPurposeUrl: `${apiUrl}/delivery/api/etransport/operation-purpose`,
    eTransportCombinedNomenclatureUrl: `${apiUrl}/delivery/api/etransport/combined-nomenclature`,
    eTransportNotificationsListUrl: `${apiUrl}/delivery/api/etransport/notification`,
    eTransportNotificationsUploadUrl: `${apiUrl}/administration/api/import/uploads`,
    eTransportActionUrl: `${apiUrl}/delivery/api/etransport/action`,
    eTransportShipmentUrl: `${apiUrl}/delivery/api/etransport/shipment`,
    eTransportAiUrl: `${apiUrl}/delivery/api/etransport/ai`,
    aiPromptUrl: `${apiUrl}/delivery/rest/ai-prompt`,

    packageTrackingUrl: `${apiUrl}/delivery/api/package-tracking`,

    productCustomsClearanceNomenclatureListUrl: `${apiUrl}/delivery/api/products-nomenclature-list`,
    productCustomsClearanceNomenclatureUrl: `${apiUrl}/delivery/api/product-nomenclature`,
    productUploadUrl: `${apiUrl}/administration/api/import/uploads`,

    unitMeasurementUrl: `${apiUrl}/delivery/api/unit-measurement`,
    vendorBlacklistItemUrl: `${apiUrl}/delivery/api/vendor/blacklist`,
    customerBlacklistItemUrl: `${apiUrl}/delivery/api/customer/blacklist`,

    namedLocationUrl: `${apiUrl}/delivery/api/named-location`,
    namedLocationPartnerUrl: `${apiUrl}/delivery/api/named-location-partner`,
    namedLocationEmployeeUrl: `${apiUrl}/delivery/api/named-location-employee`,
    employeeHubListUrl: `${apiUrl}/delivery/api/named-location-employee/employees-with-named-locations`,

    operationalTerritoryUrl: `${apiUrl}/delivery/api/operational-territory`,
    operationalTerritoryNamedLocationUrl: `${apiUrl}/delivery/api/operational-territory/add-named-locations`,
    operationalTerritoryPartnerUrl: `${apiUrl}/delivery/api/operational-territory/add-partners`,

    routedOrderTemplateUrl: `${apiUrl}/delivery/api/routed-order-template`,
    routedOrderTemplateDraftUrl: `${apiUrl}/delivery/api/routed-order-template-draft`,

    ownershipRequestUrl: `${apiUrl}/delivery/api/ownership-request`,

    externalMappingUrl: `${apiUrl}/delivery/api/external-mapping`,

    delContactPhoneableUrl: `${apiUrl}/delivery/api/contact/phoneable`,

    unedifactUrl: `${apiUrl}/delivery/api/unedifact`,
    ediOutboundMessageUrl: `${apiUrl}/delivery/api/edi-outbound-message`,
    externalVendorUrl: `${apiUrl}/delivery/api/external-vendor`,
    externalVendorAccountNumberUrl: `${apiUrl}/delivery/api/external-vendor-account-number`,
    externalVendorAutocompleteUrl: `${apiUrl}/delivery/api/external-vendor/couriers`,
    shipmentRequestExternalCourierRateUrl: `${apiUrl}/delivery/api/ship-req-ext-courier-rate`,
    orderBasedOnCourierUrl: `${apiUrl}/delivery/api/order-based-on-courier`,
    orderBasedOnCourierEnhancementUrl: `${apiUrl}/delivery/api/order-based-on-courier-enhancement`,
    courierTrackingDetailsUrl: `${apiUrl}/delivery/api/courier-tracking-details`,
    externalVendorRequestResponseUrl: `${apiUrl}/delivery/api/external-vendor-request-response`,
    externalVendorDiscountUrl: `${apiUrl}/delivery/api/external-vendor-discount`,

    saftUrl: `${apiUrl}/saf-t/api`,

    deliveryFileStorageUrl: `${apiUrl}/delivery/api/attachment`,
    crmFileStorageUrl: `${apiUrl}/crm/api/attachment`,

    resourceAllocationUrl: `${apiUrl}/delivery/api/resource-allocation`,
  };
}

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
